import React from 'react';

const Footer = () => {
  return (
    <footer className="industrial-footer">
      <div className="container">
        <div className="footer-content">
          Creada por{' '}
          <a 
            href="https://perhost.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="perhost-link"
          >
            PERHOST
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;